import {useAppDispatch} from "../../../app/hooks";
import {LoginUser} from "../../../services/UsersService";
import {open} from "../anonymizeLoginUserModal/AnonymizeLoginUserModalSlice";
import {RequireTier} from "../../auth/RequireTier";

interface AnonymizeLoginUserProps {
  loginUser: LoginUser;
}

const AnonymizeLoginUser = (props: AnonymizeLoginUserProps) => {
  const {loginUser} = props;
  const dispatch = useAppDispatch();
  const handleAnonymizeLoginUser = () => {
    dispatch(open(loginUser));
  };
  return (
    <>
      <div className="form-group">
        <label htmlFor="id" className="form-label mb-0">
          Anonymize user
        </label>
        <div className="mt-0 mb-2">
          <small className="text-muted">Hash the personal data and move to 0 account</small>
        </div>
        <RequireTier requiredTier="superadmin" policy="hide">
          <button className="btn btn-danger" onClick={handleAnonymizeLoginUser}>
            Anonymize login user
          </button>
        </RequireTier>
      </div>
    </>
  );
};

export default AnonymizeLoginUser;
